import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HostService } from '@vendasta/billing';
import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';
import { ListPurchaseFilter, listPurchaseFiltersToHTTPJson } from './list-purchases';

@Injectable({ providedIn: 'root' })
export class PurchaseService {
  constructor(private hostService: HostService, private http: HttpClient) {}

  exportCSV(filters: ListPurchaseFilter): Observable<Blob> {
    const jsonFilters = listPurchaseFiltersToHTTPJson(filters);
    return this.http
      .post(
        `${this.hostService.hostWithScheme}/purchase/export-csv`,
        { filters: jsonFilters },
        {
          observe: 'body',
          responseType: 'blob',
          withCredentials: true,
        },
      )
      .pipe(share());
  }
}
